import { Bell } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/DropdownMenu';
import { Button } from '@/components/ui/Button';
import { cn } from '@/lib/cn';
import { useListNotificationsQuery } from '@/store/api/adminApi';
import { NotificationDropdown } from './NotificationDropdown';

export function NotificationBell() {
  const { data } = useListNotificationsQuery({ read: false, limit: 10 }, { pollingInterval: 60_000 });
  const unread = data?.items?.filter((n) => !n.read).length ?? 0;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          aria-label="Notificaciones"
          className="relative h-8 w-8 p-0"
        >
          <Bell className="h-5 w-5" />
          {unread > 0 && (
            <span
              className={cn(
                'absolute -right-1 -top-1 flex h-4 min-w-[1rem] items-center justify-center',
                'rounded-full bg-destructive px-1 text-[10px] font-medium text-destructive-foreground',
                'animate-pulse',
              )}
            >
              {unread > 9 ? '9+' : unread}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="p-0">
        <NotificationDropdown />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
